<template>
  <b-form-group
    label="Geçerlilik Tarihi"
    label-for="edate"
  >
    <validation-provider
      #default="{ errors }"
      name="Geçerlilik Tarihi"
      rules="required"
    >
      <b-form-datepicker
        id="edate"
        v-model="dataItem.edate"
        v-bind="{labelNoDateSelected: 'Tarih Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
        locale="tr"
        start-weekday="1"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormDatepicker } from 'bootstrap-vue'
import { ValidationProvider, localize } from 'vee-validate'
import { required } from '@validations'

export default {
  name: 'EndDate',
  components: {
    BFormGroup,
    BFormDatepicker,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['customerPrices/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
